<div class="footer" [ngClass]="{regfooter: footerPostion()}">
  <label><em class="material-icons font_12">copyright</em> {{dateTime}} Walmart. All Rights Reserved.</label>
  <div class="right">
  <div class="footer_links"><a href="https://www.walmartsustainabilityhub.com/sustainability-privacy-notice" target="_blank" class="color_link" rel="noopener">Privacy</a></div>
  <span class="separator">|</span>
  <div class="footer_links"><a href="https://corporate.walmart.com/terms-of-use" target="_blank" class="color_link" rel="noopener">Terms of use</a></div>
  </div>
</div>
